import DeleteModal from '../../Modals/DeleteModal';
import {permissionObj} from '../../../Helpers/permission';
import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import ButtonAction from '../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../components/DivContainerBody';
import SectionCreateDeviceData from "./SubComponents/SectionCreateDeviceData";
import {AddIcon, EditIcon, TrashOutlineIcon} from "../../../components/buttons/IconButtons";
import SectionCreateDeviceOptions from "./SubComponents/SectionCreateDeviceOptions";
import SectionCreateDeviceSecurity from "./SubComponents/SectionCreateDeviceSecurity";
import SectionCreateDeviceAuthentication from "./SubComponents/SectionCreateDeviceAuthentication";
import SectionCreateDeviceLocks from "./SubComponents/SectionCreateDeviceLocks";
import {CreateUpdateDevicesApp} from "./Funtionality/CreateUpdateDevicesApp";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */

const CreateUpdateDevices = () => {

    const {data , permission, t, DEV, handleChange, handleClear,
        formSubmitted, deviceTypeAuthentications,emptyFields, id, handleDeviceAction, deleteDeviceShow,
        setDeleteDeviceShow, selectDeviceForDelete, setDeletedFlag, deleteSelectedDevices,
        location, setSelectDeviceForDelete,zoneIdProps, deviceTypeDistance, defaultDistance
    } = CreateUpdateDevicesApp();


    return (
        <>
            <HeadTittle
                name={id === undefined ? 'create' : 'update'}
                link={location?.state?.zoneNameProps !== undefined ? routes.zone.details + zoneIdProps : routes.devices.list}
            >
               {(DEV || (id === undefined ? permission?.includes(permissionObj?.WEB_DEVICE_CREATE) : permission?.includes(permissionObj?.WEB_DEVICE_UPDATE))) && (
                <ButtonAction
                    id='btn_cud_create'
                    name={id === undefined ? t('create') : t('update')}
                    className='btn-icon-add'
                    Icon={id === undefined ? AddIcon : EditIcon}
                    onClick={handleDeviceAction}
                />
                )}
                {id !== undefined && (DEV || permission?.includes(permissionObj?.WEB_DEVICE_DELETE)) &&
                <ButtonAction
                    id='btn_cud_delete'
                    name='delete'
                    className='btn-icon-delete'
                    Icon={TrashOutlineIcon}
                    onClick={() => {
                        setSelectDeviceForDelete([data.deviceId]);
                        setDeleteDeviceShow(true);
                        setDeletedFlag(false);
                    }}
                />
                }
            </HeadTittle>
            <DivContainerBody>

                <SectionCreateDeviceData data={data} handleChange={handleChange} handleClear={handleClear}
                                         emptyFields={emptyFields} t={t} id={id} location={location}/>

                <SectionCreateDeviceOptions data={data} handleChange={handleChange} t={t} emptyFields={emptyFields} deviceTypeDistance={deviceTypeDistance} defaultDistance={defaultDistance}/>

                <SectionCreateDeviceSecurity data={data} handleChange={handleChange} t={t} formSubmitted={formSubmitted}
                                             emptyFields={emptyFields}/>

                <SectionCreateDeviceAuthentication data={data} handleChange={handleChange} t={t}
                                                   formSubmitted={formSubmitted}
                                                   emptyFields={emptyFields}
                                                   deviceTypeAuthentications={deviceTypeAuthentications}
                />

                <SectionCreateDeviceLocks data={data}
                                          handleChange={handleChange}
                                          t={t}
                                          formSubmitted={formSubmitted}
                                          emptyFields={emptyFields}
                                          deviceTypeAuthentications={deviceTypeAuthentications}
                />

            </DivContainerBody>

            <DeleteModal
                show={deleteDeviceShow}
                onHide={() => setDeleteDeviceShow(false)}
                onClickFn={() => deleteSelectedDevices(selectDeviceForDelete)}
                data={selectDeviceForDelete}
                title_modal={t('delete_device')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('device')}
                onDelete={() => setDeletedFlag(true)}
            />
        </>
    );
};
export default CreateUpdateDevices;
